import { z } from "zod";
import { BindingEnum } from "../types";

const secretSchema = z.object({
  id: z.string().min(1, "ID is required"),
  created_at: z.string().optional(),
  updated_at: z.string().optional(),
  last_accessed_at: z.string().nullable(),
  binding: z.object({
    type: BindingEnum,
    id: z.string(),
  }),
  key: z.string().min(1, { message: "Key is required" }),
  description: z.string().nullable(),
});
export type Secret = z.infer<typeof secretSchema>;

const secretResponseSchema = z.object({
  items: z.array(secretSchema),
  limit: z.number(),
  offset: z.number(),
  page_count: z.number(),
  total_count: z.number(),
});
export type SecretResponse = z.infer<typeof secretResponseSchema>;

export const createSecretSchema = z.object({
  key: z.string().min(1, "ID is required"),
  value: z.string().min(1, "Secret value is required"),
  binding: z.object({
    type: BindingEnum,
  }),
  description: z.string().nullable(),
});
export type CreateSecret = z.infer<typeof createSecretSchema>;
